import { useQuery } from "react-query";

import axios from "axios";
import { GEO_MAP_SERVICE_ADDRESS } from "constants/app.constants";

export interface MapLayerAccess {
  group: string;
  name: string;
  userList: string[];
}

export const MAP_LAYER_GROUPS_QUERY_KEYS = {
  mapLayerGroups: "mapLayerGroups"
};

interface MapLayerGroupData {
  group: string;
  userList?: string[];
}

const getGeoMapOrganizationGroups = async (): Promise<MapLayerGroupData[]> => {
  const response = await axios.get(`${GEO_MAP_SERVICE_ADDRESS}/map-layer-groups-access`);

  if (response.status !== 200) {
    throw new Error(`Failed to get geo map organization groups: ${response.statusText}`);
  }

  return response.data;
};

const transformMapLayerGroups = (groupsData: MapLayerGroupData[]): MapLayerAccess[] => {
  return groupsData
    .map((group) => ({
      group: group.group,
      name: group.group,
      userList: group.userList || []
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
};

export default function useMapLayerGroupsQuery() {
  const queryInfo = useQuery<MapLayerAccess[]>({
    queryKey: [MAP_LAYER_GROUPS_QUERY_KEYS.mapLayerGroups],
    queryFn: async () => {
      const groupsData = await getGeoMapOrganizationGroups();
      return transformMapLayerGroups(groupsData);
    },
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000
  });

  return {
    ...queryInfo,
    mapLayerGroups: queryInfo.data || []
  };
}
